<template>
  <div>
    <csat-shimmer v-if="csatShimmer"></csat-shimmer>
    <div v-else class="mb100">
      <csat-header></csat-header>
      <div class="dt-pt80">
        <csat-overall-rating
          v-if="csatTemplateData?.overall"
        ></csat-overall-rating>
        <div v-for="(item, index) in ratingData" :key="index">
          <rating-card
            v-if="csatTemplateData[item]"
            :dataItem="csatTemplateData[item]"
            :heading="csatTemplateData[item]?.title"
            :subHeading="item == 'food' ? csatTemplateData[item]?.subTitle : ''"
            :borderBtm="
              item == 'money_value' ? 'border-btm-dashed' : 'border-btm-solid'
            "
            :category="csatTemplateData[item]?.type"
          ></rating-card>
        </div>
        <!-- commentsData -->
        <div class="rating-container" v-if="commentsData">
          <p class="fs-16 fw-700 w100">{{ commentsData?.title }}</p>
          <textarea
            name="rating-textarea"
            :placeholder="commentsData?.subTitle"
            class="rating-textarea"
            :value="inputValue"
            @input="commentInputChange"
            :class="{ 'border-red': commentError }"
          ></textarea>
          <p v-if="commentError" class="fs-11 color-error">
            {{ commentError }}
          </p>
          <!-- <div
            v-if="commentsData?.showRaiseConcernButton"
            class="raise-concern"
          >
            <label class="rating-checkbox">
              <input
                type="checkbox"
                v-model="checked"
                @click="handleCheckClick"
              />
              <span class="check-mark"></span>
              <p class="fs-12 color-grey">
                {{ commentsData?.raiseConcernButtonText }}
              </p>
            </label>
            <span
              :class="[
                this.inputValue.length > 30 ? 'color-success' : 'color-error',
              ]"
              v-if="checked"
              >{{ this.inputValue.length }}/30 (min)</span
            >
          </div> -->
        </div>

        <div class="rating-container" v-if="!isLoggedIn">
          <p class="fs-16 fw-700 w100">Registered Mobile Number</p>
          <div
            class="mobile-input-csat"
            :class="{ hasFocus: mobileFocus || mobileNo }"
          >
            <span class="mobile-code">+91</span>
            <input
              id="mobileNumberInput"
              ref="mobileNumberInput"
              type="text"
              name="mobileNoInput"
              placeholder="Mobile Number (required)"
              inputmode="numeric"
              maxlength="10"
              v-model="mobileNo"
              @focus="setMobileFocus(true)"
              @blur="setMobileFocus(false)"
              @input="
                (event) =>
                  (mobileNo = event.target.value.replace(/[^\d]+/g, ''))
              "
            />
          </div>
        </div>
      </div>
      <div
        class="submit-rating-cta"
        :class="{ 'bottom-nav': clientPlatform == 'Web' }"
      >
        <div
          class="line-btn sm repeat-btn secondary w100"
          @click="submitRating($event, '')"
          v-ripple
        >
          Submit Rating
        </div>
      </div>
    </div>
    <csat-thank-you
      :thanksProps="feedbackResponse"
      v-if="showCsatThankYou"
    ></csat-thank-you>
    <CustomErrorModal @okClick="goToPreviousPage" />
    <toast-msg
      v-if="csatRatingError || mobileNoError"
      :data-text="
        csatRatingError
          ? 'Please enter a rating'
          : 'Please enter a valid mobile number'
      "
      data-style="item-toast-msg"
      data-text-color="textWhite"
    />
  </div>
</template>
<script>
import CsatShimmer from "./CsatShimmer.vue";
import CsatOverallRating from "./CsatOverallRating.vue";
import { keyMapsAction, keyMapsMutation } from "../../helpers/storeKeys";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import RatingCard from "./RatingCard.vue";
import CsatHeader from "./CsatHeader.vue";
import CsatThankYou from "./CsatThankYou.vue";
import CustomErrorModal from "../payment/Reusable-Component/CustomErrorModal.vue";
import { clientPlatform } from "../../config/apiEndpoints";
import { defineAsyncComponent } from "vue";
import { validateMobile } from "../../helpers/loginUtils";
import PageNames from "../../config/pageNames";
export default {
  name: "CsatLandingPage",
  components: {
    CsatShimmer,
    CsatOverallRating,
    RatingCard,
    CsatHeader,
    CsatThankYou,
    CustomErrorModal,
    ToastMsg: defineAsyncComponent(() => import("../ToastMsg.vue")),
  },
  data() {
    return {
      ratingData: ["food", "delivery", "money_value"],
      inputValue: "",
      checked: false,
      commentError: "",
      clientPlatform,
      mobileNo: LocalStorageFunc.getUserMobileNo() || "",
      mobileFocus: false,
      mobileNoError: false,
    };
  },
  mounted() {
    this.$store.dispatch(keyMapsAction.CSAT_FEEDBACK_API, {});
  },
  methods: {
    submitRating() {
      if (!this.isMinValid) {
        this.commentError = "Your feedback should have at least 30 characters";
        return;
      }
      if (this.commentError) {
        return;
      }
      let payload = {};
      // if (Utility.getParamDataFromUrl("orderMode") === "OFFLINE") {
        if (validateMobile(this.mobileNo)) {
          this.mobileNoError = false;
          payload = {
            mobile: this.mobileNo,
          };
        } else {
          this.mobileNoError = true;
          setTimeout(() => {
            this.mobileNoError = false;
          }, 2000);
          return;
        }
      // }
      if (this.isNewFeedback) {
        this.$store.dispatch(keyMapsAction.SUBMIT_CSAT_FEEDBACK_API, payload);
      } else {
        this.$store.dispatch(keyMapsAction.UPDATE_CSAT_FEEDBACK_API, payload);
      }
    },
    handleCheckClick(e) {
      Utility.vibrateOnClick();
      this.checked = e.target.checked;
      this.$store.commit(keyMapsMutation.UPDATE_RAISE_TICKET, e.target.checked);
    },
    commentInputChange(e) {
      this.inputValue = e.target.value;
      if (this.inputValue.length >= 250) {
        this.commentError = "You have reached maximum character limit of 250";
      } else if (this.inputValue.length > 30 && this.checked) {
        this.commentError = "";
      }
      this.$store.commit(keyMapsMutation.UPDATE_COMMENT, this.inputValue);
    },
    goToPreviousPage() {
      if (this.showCsatThankYou) {
        if (
          LocalStorageFunc.getSessionStorageKey("screenName") ===
          PageNames.ORDERHISTORY_PAGE
        ) {
          Utility.sendToOrderHistory();
        } else {
          Utility.sendToHomepageScreen();
        }
      }
    },
    setMobileFocus(flag) {
      this.mobileFocus = flag;
    },
  },
  computed: {
    csatShimmer() {
      return this.$store.state.CsatFeedback.csatShimmer;
    },
    isLoggedIn() {
      return LocalStorageFunc.isLoggedIn();
    },
    csatTemplateData() {
      return this.$store.state.CsatFeedback.csatTemplateData;
    },
    selectedRating() {
      return this.$store.state.CsatFeedback.selectedRating;
    },
    commentsData() {
      return this.csatTemplateData?.comments?.subCategories?.[0]?.ratings?.[
        this.selectedRating
      ];
    },
    orderDetails() {
      return this.$store.state.CsatFeedback.orderDetails;
    },
    isMinValid() {
      if (this.commentsData?.showRaiseConcernButton && this.checked) {
        return this.inputValue.length >= 30;
      }
      return true;
    },
    isNewFeedback() {
      return this.$store.state.CsatFeedback.isNewFeedback;
    },
    feedbackResponse() {
      return this.$store.state.CsatFeedback.submitFeedBackResponse?.data;
    },
    showCsatThankYou() {
      return this.$store.state.CsatFeedback.showThankYou;
    },
    csatRatingError() {
      return this.$store.state.CsatFeedback.csatRatingError;
    },
  },
};
</script>
